import { render, staticRenderFns } from "./AddEditWorker.vue?vue&type=template&id=0020af4c&scoped=true"
import script from "./AddEditWorker.vue?vue&type=script&lang=js"
export * from "./AddEditWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020af4c",
  null
  
)

export default component.exports